import React from "react";
import { STATE_LABEL } from "../../lib/ratings";
import "./Reviews.css";

// Draft → Ready → Presented.
//
// Presenting is the one transition with a consequence, so it confirms first. The select
// is controlled, so cancelling simply leaves the value where it was — there is nothing to
// roll back.
const STATES = ["draft", "ready", "presented"];

const StatusControl = ({ value, onChange, disabled, compact, ariaLabel = "Assessment status" }) => {
  const choose = (next) => {
    if (next === value) return;
    if (next === "presented" &&
        !window.confirm("Mark this review as presented?\n\nIts contents lock once you do — ratings, items and categories can no longer be changed. Cloning it is how you carry on from here.")) {
      return;
    }
    onChange(next);
  };

  return (
    <select
      className={`v2-input v2-statusselect${compact ? " v2-statusselect--compact" : ""}`}
      value={value}
      disabled={disabled}
      aria-label={ariaLabel}
      onChange={(e) => choose(e.target.value)}
    >
      {STATES.map((s) => <option key={s} value={s}>{STATE_LABEL[s]}</option>)}
    </select>
  );
};

export default StatusControl;
